import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import SearchBox from './SearchBox';

const navItems = [
  { label: '首页', to: '/' },
  { label: '影视作品', to: '/category' },
  { label: '明星资料', to: '/stars' },
  { label: '动态资讯', to: '/news' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-6 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold tracking-tight text-foreground-950">河北彩花影视大全</span>
            <span className="mt-1 text-[10px] tracking-[0.2em] text-foreground-400">HBH MOVIE DATABASE</span>
          </span>
        </Link>

        <nav className="ml-2 hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-[300px] lg:block">
          <SearchBox />
        </div>

        <div className="ml-auto flex items-center gap-1 lg:hidden">
          <button
            type="button"
            aria-label="搜索"
            onClick={() => setMobileSearchOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMobileOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-100"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {mobileSearchOpen && (
        <div className="border-t border-background-200 px-4 py-3 lg:hidden">
          <SearchBox />
        </div>
      )}

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}